module.exports = __webpack_public_path__ + "img/9_105.a8641207.png";